export const getIntervalFromEnv = (key: string) => {
    return process.env[key] || '3000'
}
